const creditScoreCardStrings = {
  title: 'Credit Score',
  delta: {
    noChange: 'No change',
    pts: 'pts',
  },
};

export default creditScoreCardStrings;
